import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import counselingCenterForms from './counselingCenterForms';
import type { Client } from '../../../../common/types/client';
import ListItemField from '../../../../common/components/ListItemField';
import measureForm from '../measure/measureForm';
import MeasureRow from '../measure/MeasureRow';
import FormWrapper from '../../../../common/components/FormWrapper';
import documentForm from '../document/docmentForm';
import DocumentRow from '../document/DocumentRow';
import ContactAttemptRow from '../contactAttempts/ContactAttemptRow';
import contactAttemptForm from '../contactAttempts/contactAttemptForm';

type Props = {
  client: Client;
  updateClient: (client: Client) => void;
  saveClient?: (client: Client) => void;
};

function CounselingCenterClientForm({ client, updateClient, saveClient }: Props) {
  return (
    <Stack px={3} pt={1} pb={2} overflow='auto scroll'>
      <Box component='form' noValidate autoComplete='off' maxWidth='650px'>
        {counselingCenterForms.map((form) => (
          <FormWrapper key={form.key} form={form} item={client} update={updateClient} save={saveClient} />
        ))}
        <ListItemField
          items={client.documents || []}
          headline='Dokumente'
          margin={5}
          itemForm={documentForm}
          renderItemRow={(item) => <DocumentRow document={item} />}
          handleSave={(value) => {
            if (saveClient !== null && saveClient !== undefined) {
              saveClient({
                ...client,
                documents: value,
              });
            }
          }}
          handleChange={(value) => {
            updateClient({
              ...client,
              documents: value,
            });
          }}
        />
        <ListItemField
          items={client.contactAttempts || []}
          headline='Kurzkontakte'
          margin={5}
          itemForm={contactAttemptForm}
          renderItemRow={(item, itemForm) => <ContactAttemptRow contactAttempt={item} itemForm={itemForm} />}
          handleSave={(value) => {
            if (saveClient !== null && saveClient !== undefined) {
              saveClient({
                ...client,
                contactAttempts: value,
              });
            }
          }}
          handleChange={(value) => {
            updateClient({
              ...client,
              contactAttempts: value,
            });
          }}
        />
        <ListItemField
          items={client.measures || []}
          headline='Beratung'
          margin={5}
          preallocateItem={{
            label: 'Telefonische Beratung',
            value: {
              type: 'telephoneConsultation',
              topic: ['domesticViolence'],
              duration: 59,
            },
          }}
          itemForm={measureForm}
          renderItemRow={(item, itemForm) => <MeasureRow measure={item} itemForm={itemForm} />}
          handleSave={(value) => {
            if (saveClient !== null && saveClient !== undefined) {
              saveClient({
                ...client,
                measures: value,
              });
            }
          }}
          handleChange={(value) => {
            updateClient({
              ...client,
              measures: value,
            });
          }}
        />
      </Box>
    </Stack>
  );
}

export default CounselingCenterClientForm;
